module.exports = __webpack_public_path__ + "static/media/IMG_4833.64efc72d.JPG";